import React, {useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { initMessage } from '../../api/chat'
import { unStarUser } from '../../api/social'
import './index.sass'


export default function StaredUserCard({username, image, name, id}) {
    const [isDeletePromptVisible, setIsDeletePromptVisible] = useState(false)
    const userID = useSelector(state => state.userState.id);
    
    const history = useHistory();

    const removeUser = (e) => {
        e.stopPropagation();
       unStarUser(id)
    }

    const gotoProfile = (e) => {
        e.stopPropagation();

        history.push({
            pathname: `/user/${username}`
        })    
    }

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const handleDeletePostPrompt = async (e) => {
        e.stopPropagation();

        if (!isDeletePromptVisible)
            setIsDeletePromptVisible(true)
        else {
            document.getElementById('deletePrompt').style.transform = 'scale(0)'
           // await sleep(1000)
            setIsDeletePromptVisible(false)

        }
    }


    const handleDeleteDialogTransition = async () => {
        if (isDeletePromptVisible) {
            document.getElementById('deletePrompt').style.transform = 'scale(1)'
            await sleep(1000)
        }
    }

    const initMsg = async () => {
        const channelID = await initMessage(userID, id)
        history.push('/message', {remoteID: id, channelID: channelID})
    }

    useEffect(() => {
        handleDeleteDialogTransition()
    }, [isDeletePromptVisible])



    return (
        <div className='staredUserWrapper' onClick={gotoProfile}>
            <div id="staredUserContent">
                <div className='userimage'>
                    <img src={(image.length > 0) ? image : require('../../assets/img/viewerpic.svg')} alt={username} />
                </div>
                <div className='userinfo'>
                    <p className='username'>{username}</p>
                    <p className='name'>{name}</p>
                </div> 
            </div>
            <div id="staredUserActions">
            <div onClick={initMsg} id='message'>
                <img src={require('../../assets/icons/send.svg')} alt='message' />
            </div>
            <div id='delete' onClick={handleDeletePostPrompt}>
            {isDeletePromptVisible && <div id="deletePrompt">
                                    <div id="deletePromptWrapper">
                                        <img src={require("../../assets/icons/polygon.svg")} />
                                        <div id="deleteDialog">
                                            <h1>Are you sure?</h1>
                                            <div id="deleteDialogActions">
                                                <div id="circleCross">
                                                    <img onClick={handleDeletePostPrompt} src={require("../../assets/icons/cross.svg")} />
                                                </div>
                                                <div onClick={removeUser}  id="postDeleteButton">
                                                    <p>Delete</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                <img onClick={handleDeletePostPrompt}  src={require('../../assets/icons/trash_a.svg')} alt='delete' />
            </div>
        </div>
        </div>
    )
}
